<template>
    <Link href="/" class="flex flex-shrink-0 items-center  py-3  px-4">
        <img class="h-8 w-auto" src="/img/logo-black.svg" alt="Landscape">
    </Link>
</template>
<script>
import {Link} from '@inertiajs/vue3';

export default {
    components: {
        Link
    }
};
</script>
